import { SupportedLanguages } from '@common/enums/supported-languages.enum';
import { ILang } from '@core/i18n/translates.interface';

export const LANG_LIST: ILang[] = [
  { code: SupportedLanguages.en, name: 'English', culture: 'en-US', iconName: 'en' },
  { code: SupportedLanguages.fr, name: 'Français', culture: 'fr-FR', iconName: 'fr' },
  { code: SupportedLanguages.pt, name: 'Português', culture: 'pt-PT', iconName: 'pt' },
  { code: SupportedLanguages.es, name: 'Español', culture: 'es-ES', iconName: 'es' },
];

export const TERM_AND_CONDITIONS_LINKS_BY_LANG: {
  [Key in SupportedLanguages]: `https://linkhms.com/${`${SupportedLanguages}/` | ''}terms-and-conditions/`;
} = {
  [SupportedLanguages.en]: `https://linkhms.com/terms-and-conditions/`,
  [SupportedLanguages.fr]: `https://linkhms.com/${SupportedLanguages.fr}/terms-and-conditions/`,
  [SupportedLanguages.pt]: `https://linkhms.com/terms-and-conditions/`,
  [SupportedLanguages.es]: `https://linkhms.com/terms-and-conditions/`,
};

export const LANG_DEFAULT: ILang = LANG_LIST[0] as ILang;
